import { D as DialogExt } from './dialog-D6y3d_r7.js';
import './focus-trap.esm-CoH9VLSd.js';
import './pubsub-CoPYzvVm.js';
import './notyf-DIw0RvBj.js';

class DrawerElement extends DialogExt {
  open() {
    super.open();

    // Auto-focus search input
    const searchInput = this.querySelector('input[type="search"], input[name="q"]');
    if (searchInput) setTimeout(() => searchInput.focus(), 50);

    // Close the drawer when the window is resized
    window.addEventListener('resize', () => super.close(), { once: true });
  }
}

customElements.define('drawer-element', DrawerElement);
